/**
 * @module Worker
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/* tslint:disable*/ // Need to support all data types
// It is not considering import as declaration , throwing lint error at import statement itself

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { WorkerOutput } from '@core/worker/core/worker-output';

export class WorkerUtils {
  private static validMethods: Set<string> = new Set([
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
  ]);

  public static flattenRequestMethod(method: string): string {
    // switch (method) {
    //   case RequestMethod.Delete:
    //     return 'DELETE';
    //   case RequestMethod.Get:
    //     return 'GET';
    //   case RequestMethod.Head:
    //     return 'HEAD';
    //   case RequestMethod.Options:
    //     return 'OPTIONS';
    //   case RequestMethod.Patch:
    //     return 'PATCH';
    //   case RequestMethod.Post:
    //     return 'POST';
    //   case RequestMethod.Put:
    //     return 'PUT';
    //   default:
    if (WorkerUtils.isValidMethod(method)) {
      return method;
    } else {
      throw new Error(`Not a valid request method: ${method}`);
    }
  }

  public static isValidMethod(method: string): boolean {
    return this.validMethods.has(method.toUpperCase());
  }

  public static buildResponse(output: WorkerOutput): HttpResponse<Object> {
    const resOptsArgs = {
      body: {},
      status: 0,
      statusText: '',
      headers: null,
      url: '',
    };
    // if (output.data) {
    //   resOptsArgs.body = output.data;
    // @TODO make sure data is of type string | Object | FormData | ArrayBuffer | Blob
    // }
    // if (output.statusText) {
    //   resOptsArgs.statusText = output.statusText;
    // }
    // if (output.status) {
    //   resOptsArgs.status = output.status;
    // }
    // // @TODO figure out Headers
    // if (output.headers) {
    //   resOptsArgs.headers = new Headers(output.headers);
    // }

    // /* if (output.type ) {
    //   resOptsArgs.type = output.type;
    // } */
    // if (output.url) {
    //   resOptsArgs.url = output.url;
    // }
    resOptsArgs.body = typeof output.data === 'string' ? JSON.parse(output.data) : output.data;
    resOptsArgs.statusText = output.statusText;
    resOptsArgs.status = output.status;
    if (output.headers) {
      resOptsArgs.headers = new HttpHeaders(output.headers);
    }
    resOptsArgs.url = output.url;
    // const resOpts: ResponseOptions = new ResponseOptions(resOptsArgs);
    return new HttpResponse(resOptsArgs);
  }
  /**
   * Determines browser is IE or not
   * @return boolean
   */
  public static isIE(): boolean {
    const ieReg = /msie|Trident.*rv[ :]*11\./gi;
    return ieReg.test(window.navigator.userAgent);
  }
}
